import '../styles/FormationCard.css';
import React, { useRef } from "react";

/**
 * FormationCard
 * Props:
 *   title    {string}  - Título de la tarjeta
 *   value    {string|number} - Valor principal
 *   subtitle {string}  - Texto secundario
 *   icon     {string}  - Clase de icono FontAwesome (ej. "fa-server")
 *   accent   {string}  - Variante de color del acento: "total" | "occupancy" | ...
 *   status   {string}  - Color del acento superior: "success" | "danger" | "neutral"
 *   options  {Array}   - Lista de opciones del desplegable: [{ label, onClick }]
 */
const FormationCard = ({
    title = "Pendientes",
    value = 0,
    subtitle = "",
    icon = "fa-server",
    portrait = null,
    accent = "total",
    status = "neutral",
    options = [],
    progress = null,
    isLocked = false,
}) => {
    const dropdownRef = useRef(null);

    const imgPrueba = "/images/machines/lagoon-party.avif";

    return (
        <div
            className={`formation-card formation-accent-${accent} formation-status-${isLocked ? 'locked' : status}`}
            ref={dropdownRef}
            style={isLocked ? { opacity: 0.6, cursor: 'not-allowed' } : {}}
        >
            <div className="formation-card-accent-bar" />
            <div className="formation-card-inner">
                <div className="formation-card-header" style={isLocked ? { cursor: 'not-allowed' } : {}}>
                    <div className="formation-card-left">
                        <div className="formation-card-icon">
                            <i className={`fas ${isLocked ? 'fa-lock' : icon}`} />
                        </div>
                        <div className="formation-card-title">{title}</div>
                    </div>
                    <div className="formation-card-right">
                        <div className="formation-card-value">{value}</div>
                        {subtitle && (
                            <div className="formation-card-subtitle">{subtitle}</div>
                        )}
                    </div>
                </div>

                {progress !== null && (
                    <div style={{ position: 'relative', marginTop: 8 }}>
                        {(portrait || imgPrueba) && (
                            <div style={{
                                height: 250,
                                overflow: 'hidden',
                                borderRadius: 6,
                            }}>
                                <img
                                    src={portrait || imgPrueba}
                                    alt={title}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                                />
                            </div>
                        )}
                        <div style={{
                            position: portrait || imgPrueba ? 'absolute' : 'relative',
                            bottom: 0, left: 0, right: 0,
                            display: 'flex', alignItems: 'center', gap: 8,
                            padding: '4px 8px',
                            background: portrait || imgPrueba ? 'rgba(0,0,0,0.30)' : 'transparent',
                            borderRadius: '0 0 6px 6px',
                        }}>
                            <div className="formation-card-progress-track" style={{ flex: 1 }}>
                                <div
                                    className="formation-card-progress-bar"
                                    style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
                                />
                            </div>
                            <span className="formation-card-progress-label">{progress}%</span>
                        </div>
                    </div>
                )}

                {options.length > 0 && (
                    <div className="formation-card-dropdown">
                        {options.map((opt, idx) => (
                            <React.Fragment key={idx}>
                            <div className="formation-card-dropdown-divider"/>
                            <div className="formation-card-dropdown-row">
                                <button
                                    className="formation-card-dropdown-item"
                                    disabled={opt.status === "locked"}
                                    style={opt.status === "locked" ? { opacity: 0.45, cursor: "not-allowed" } : {}}
                                    onClick={() => { if (opt.status !== "locked") { opt.onClick && opt.onClick(); } }}
                                >
                                    {opt.icon && <i className={`fas ${opt.icon} me-2`} />}
                                    {opt.label}
                                </button>
                                <span className={`formation-card-status-icon formation-card-status-${opt.status}`}>
                                    {opt.status === "done"    && <i className="fas fa-circle-check" />}
                                    {opt.status === "error"   && <i className="fas fa-circle-xmark" />}
                                    {opt.status === "locked"  && <i className="fas fa-lock" />}
                                    {(!opt.status || opt.status === "pending") && <i className="fas fa-clock" />}
                                </span>
                            </div>
                            </React.Fragment>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default FormationCard;


